import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ExpertiseSection = ({ language }) => {
  const content = {
    en: {
      title: "Our Expertise",
      subtitle: "Comprehensive Coffee Trading Services",
      services: [
        {
          icon: "Search",
          title: "Quality Assessment",
          description: "Expert evaluation of green coffee beans using international standards and comprehensive testing protocols"
        },
        {
          icon: "FileCheck",
          title: "Supplier Verification",
          description: "Rigorous verification process ensuring all suppliers meet our quality and ethical standards"
        },
        {
          icon: "TrendingUp",
          title: "Market Intelligence",
          description: "Real-time market analysis and pricing insights for informed purchasing decisions"
        },
        {
          icon: "Truck",
          title: "Logistics Management",
          description: "End-to-end shipping coordination from African farms to Chinese ports with full tracking"
        },
        {
          icon: "Shield",
          title: "Certification Support",
          description: "Assistance with organic, fair trade, and specialty coffee certifications"
        },
        {
          icon: "MessageSquare",
          title: "Bilingual Support",
          description: "Seamless communication in English and Chinese for smooth business operations"
        }
      ],
      imageAlt: "Professional coffee quality control specialist examining green coffee beans with magnifying glass in modern laboratory setting"
    },
    zh: {
      title: "我们的专业知识",
      subtitle: "全面的咖啡贸易服务",
      services: [
        {
          icon: "Search",
          title: "质量评估",
          description: "使用国际标准和全面测试协议对生咖啡豆进行专业评估"
        },
        {
          icon: "FileCheck",
          title: "供应商验证",
          description: "严格的验证流程，确保所有供应商符合我们的质量和道德标准"
        },
        {
          icon: "TrendingUp",
          title: "市场情报",
          description: "实时市场分析和定价洞察，助力明智的采购决策"
        },
        {
          icon: "Truck",
          title: "物流管理",
          description: "从非洲农场到中国港口的端到端运输协调，全程跟踪"
        },
        {
          icon: "Shield",
          title: "认证支持",
          description: "协助获得有机、公平贸易和精品咖啡认证"
        },
        {
          icon: "MessageSquare",
          title: "双语支持",
          description: "英语和中文无缝沟通，确保业务顺利运营"
        }
      ],
      imageAlt: "专业咖啡质量控制专家在现代实验室环境中使用放大镜检查生咖啡豆"
    }
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-4">
            {content?.[language]?.title}
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            {content?.[language]?.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center mb-12">
          <div className="order-2 lg:order-1">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {content?.[language]?.services?.map((service, index) => (
                <div
                  key={index}
                  className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-smooth"
                >
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                    <Icon name={service?.icon} size={24} color="var(--color-primary)" />
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
                    {service?.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {service?.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative h-[300px] md:h-[400px] lg:h-[600px] rounded-lg overflow-hidden shadow-lg">
              <Image
                src="https://images.pexels.com/photos/4226881/pexels-photo-4226881.jpeg"
                alt={content?.[language]?.imageAlt}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;